// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import { i18n } from '@/i18n'
import VeeValidate from '@/validation'
import VueFilter from 'vue-filter'
import VueMaterial from 'vue-material'
import VueMeta from 'vue-meta'
import autofocus from 'vue-autofocus-directive'
import 'vue-material/dist/vue-material.css'
import './assets/theme.scss'

Vue.use(VueMaterial)
Vue.use(VueFilter)
Vue.use(VeeValidate, { i18n: i18n, inject: true })
Vue.use(VueMeta)
Vue.directive('autofocus', autofocus)

// const isProd = process.env.NODE_ENV === 'production'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js